import { productApi } from '@/api/index.js'

// 用户状态管理
export default {
  state: {
    isLoggedIn: false,
    user: null,
    favorites: new Set() // 使用 Set 存储已收藏的产品 ID
  },
  
  login(userData) {
    // userData 应包含 token, id, firstname, lastname, email, phone, score 等
    this.state.isLoggedIn = true
    this.state.user = {
      ...userData,
      name: `${userData.firstname} ${userData.lastname}`,
      type: userData.type || 1 // 1:买家 2:卖家
    }
    localStorage.setItem('user', JSON.stringify(this.state.user))
    
    // 登录后加载收藏列表
    this.loadFavorites()
  },
  
  logout() {
    this.state.isLoggedIn = false
    this.state.user = null
    this.state.favorites.clear()
    localStorage.removeItem('user')
    localStorage.removeItem('favorites')
  },
  
  checkAuth() {
    const user = localStorage.getItem('user')
    if (user) {
      try {
        this.state.user = JSON.parse(user)
        this.state.isLoggedIn = true
        this.loadFavorites()
      } catch (e) {
        console.error('Parse user data error:', e)
        this.logout()
      }
    }
  },
  
  updateUserInfo(userData) {
    if (this.state.user) {
      this.state.user = {
        ...this.state.user,
        ...userData
      }
      localStorage.setItem('user', JSON.stringify(this.state.user))
    }
  },
  
  // 加载收藏列表（从 localStorage）
  loadFavorites() {
    if (!this.state.isLoggedIn) {
      this.state.favorites.clear()
      return
    }
    
    try {
      const favorites = localStorage.getItem('favorites')
      if (favorites) {
        const favArray = JSON.parse(favorites)
        this.state.favorites = new Set(favArray)
      } else {
        this.state.favorites = new Set()
      }
    } catch (e) {
      console.error('Parse favorites error:', e)
      this.state.favorites = new Set()
    }
  },
  
  // 保存收藏列表到 localStorage
  saveFavorites() {
    const favArray = Array.from(this.state.favorites)
    localStorage.setItem('favorites', JSON.stringify(favArray))
  },
  
  // 切换收藏状态（调用后端接口）
  async toggleFavorite(productId) {
    if (!this.state.isLoggedIn) {
      return Promise.reject(new Error('请先登录'))
    }
    
    try {
      // 调用后端接口
      await productApi.setCollect(productId)
      
      // 更新本地状态
      if (this.state.favorites.has(productId)) {
        this.state.favorites.delete(productId)
      } else {
        this.state.favorites.add(productId)
      }
      
      // 保存到 localStorage
      this.saveFavorites()
      
      return Promise.resolve()
    } catch (error) {
      console.error('Toggle favorite error:', error)
      return Promise.reject(error)
    }
  },
  
  // 检查是否已收藏
  isFavorited(productId) {
    return this.state.favorites.has(productId)
  },
  
  // 从产品列表数据中同步收藏状态
  syncFavoritesFromProducts(products) {
    if (!this.state.isLoggedIn || !products) return
    
    products.forEach(product => {
      if (product.iscollect === 1) {
        this.state.favorites.add(product.id)
      }
    })
    
    this.saveFavorites()
  }
}
